import { api } from '@/lib/api/client';

export { getOrganizationsApi, getOrganizationApi, sendOrgMessageApi } from '@api-client/organizations';
export type { GetOrganizationsParams, Organization } from '@api-client/organizations';

export async function createOrgAdminRequestApi(
  orgId: number,
  payload: { message?: string },
): Promise<{ id: number; uid: string }> {
  return api.post(`/organizations/${orgId}/admin-requests`, payload);
}
